import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import "./styles/index.css";
import App from "./App";
import Sidebar from "./components/mailbox/Sidebar";
import Middlebar from "./components/mailbox/Middlebar";
import Rightpage from "./components/mailbox/Rightpage";
import NewMail from "./components/mailbox/NewMail";
import { Provider } from "react-redux";
import Store from "./reduxContainer/Store";
import CalenderPage from "./components/calender/CalenderPage";
import SettingsPage from "./components/settings/SettingsPage";
import MessagesPage from "./components/messages/MessagesPage";
import MeetingPage from "./components/meetings/MeetingPage";
import InfoPage from "./components/info/InfoPage";
import ProfilePage from "./components/profile/ProfilePage";
import ErrorPage from "./ErrorPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <CalenderPage /> },
      {
        path: "/task-board",
        element: <CalenderPage />,
      },
      {
        path: "/mailbox",
        element: <Sidebar />,
        children: [
          {
            path: "/mailbox/new-mail",
            element: <NewMail />,
          },
          {
            path: "/mailbox/inbox",
            element: (
              <>
                <Middlebar />
              </>
            ),
            children: [{
              path: "/mailbox/inbox/:data",
              element: <Rightpage />
            }]
          },
          {
            path: "/mailbox/sent-mails",
            element: (
              <>
                <Middlebar />
              </>
            ),
            children: [{
              path: "/mailbox/sent-mails/:data",
              element: <Rightpage />
            }]
          },
          {
            path: "/mailbox/starred",
            element: (
              <>
                <Middlebar />
                <Outlet />
              </>
            ),
            children: [{
              path: "/mailbox/starred/:data",
              element: <Rightpage />
            }]
          },
          {
            path: "/mailbox/draft",
            element: (
              <>
                <Middlebar />
                <Outlet />
              </>
            ),
            children: [{
              path: "/mailbox/draft/:data",
              element: <Rightpage />
            }]
          },
          {
            path: "/mailbox/deleted-mails",
            element: (
              <>
                <Middlebar />
                <Outlet />
              </>
            ),
            children: [{
              path: "/mailbox/deleted-mails/:data",
              element: <Rightpage />
            }]
          },
          {
            path: "/mailbox/spam-mails",
            element: (
              <>
                <Middlebar />
                <Outlet />
              </>
            ),
            children: [{
              path: "/mailbox/spam-mails/:data",
              element: <Rightpage />
            }]
          },
        ],
      },
      {
        path: "/messages",
        element: <MessagesPage />,
      },
      {
        path: "/meetings",
        element: <MeetingPage />,
      },
      {
        path: "/info",
        element: <InfoPage />,
      },
      {
        path: "/settings",
        element: <SettingsPage />,
      },
      {
        path: "/profile",
        element: <ProfilePage />,
      },
      {
        path: "/error",
        element: <ErrorPage />,
      },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Provider store={Store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);
